/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Decorators from '../../Decorators';
import UpdateableComponentBase from './UpdateableComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.requireComponent(cc.Sprite)
export default class UpdateableToggleSpriteComponent extends UpdateableComponentBase<cc.Sprite, boolean>
{
    /** Sprite to show when boolean is false. */
    @property({ type: cc.Sprite })
    protected onSprite: cc.Sprite = null;

    /** Sprite to show when boolean is false. */
    @property({ type: cc.Sprite })
    protected offSprite: cc.Sprite = null;

    /** This updateable [[cc.Sprite]]. */
    protected component: cc.Sprite;

    /** Tree parent node. */
    private _parentNode: cc.Node = null;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.component = this.onSprite || this.getComponent(cc.Sprite);

        this._parentNode = this.component.node.parent;
        this.configureParent();

        this.node.on(cc.Node.EventType.TOUCH_END, this.toggleObservable);
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (this.node) { this.node.off(cc.Node.EventType.TOUCH_END, this.toggleObservable); }
        super.onDestroy();
    }

    /** @hidden */
    @Decorators.BindThis()
    private toggleObservable(): void
    {
        if (this.observable) { this.observable.Value = !this.observable.Value; }
    }

    /** Intial position and parent configuraitons. */
    private configureParent(): void
    {
        this.component.enabled = false;
        this.component.node.active = true;

        this.offSprite.enabled = false;
        this.offSprite.node.active = true;

        if (!this.offSprite.node.isChildOf(this._parentNode))
        {
            this._parentNode.addChild(this.offSprite.node);
            this.offSprite.node.setPosition(this.component.node.position);
        }
    }

    /** Update ui based on observable. */
    protected updateUI = (): void =>
    {
        this.component.enabled = this.observable.Value;
        this.offSprite.enabled = !this.observable.Value;
    }
}
